var metaCustomJs   = document.querySelector('meta[name="custom-js"]');
let isIntlTelInput = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isIntlTelInput = true;
  }
}

const intlTelInput = (
  await import(`${isIntlTelInput ? `https://ga.jspm.io/npm:intl-tel-input@18.3.0/build/js/intlTelInput.js` : `intl-tel-input`}`)
).default

import countryCodes from './country-codes';

$(document).ready(function() {
  // const form   = document.querySelector("form");
  const inputs = document.querySelectorAll('.phone-number');

  inputs.forEach(function(input) {
    if (input && input.dataset.intlTelInput) { return } // Handle duplicate init

    var orderCountryCodes = input.dataset.orderCountryCodes
    if (orderCountryCodes == undefined) {
      orderCountryCodes = []
    } else {
      orderCountryCodes = orderCountryCodes.split(', ')
    }

    const iti = new intlTelInput(input, {
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
      separateDialCode: true,
      preferredCountries: orderCountryCodes,
      formatOnDisplay: false
    });

    input.dataset.intlTelInput = "true"; // Handle duplicate init

    let contactNumberCode = input.closest(".form-group").querySelector(".contact-number-code")
    if (contactNumberCode == undefined) {
      contactNumberCode = document.querySelector('.contact-number-code')
    }

    if (iti.selectedCountryData.dialCode !== undefined) {
      contactNumberCode.value = iti.selectedCountryData.dialCode
    }

    input.addEventListener("countrychange", function() {
      if (contactNumberCode != null) {
        contactNumberCode.value = iti.selectedCountryData.dialCode
      }
    });

    selectedContactNumberCode(iti)

    $('.iti__selected-flag').click(function () {
      if ($('body.iti-mobile').length) {
        $('.iti--container').css('top', $(this)[0].getBoundingClientRect().top + 40 + 'px');
        $('.iti--container').css('left', $(this)[0].getBoundingClientRect().left + 'px');
      }
    });

    input.addEventListener('keypress', function (e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    });

    $('.iti__country-list').attr('style', 'position: fixed;')

    if (input.dataset.customWidth == true || input.dataset.customWidth == 'true') {
      var phoneField = $('#phoneField')
      if (phoneField.length >= 1) {
        phoneField.attr('style', 'padding-bottom: 220px;')
      }
    }
  });

  function selectedContactNumberCode(iti) {
    var select = $('.contact-number-code');
    var countryCode = select.val();
    countryCodes.forEach((el) => {
      if (el.dial_code === countryCode) {
        var countrySelected = el.code.toLowerCase();
        iti.setCountry(countrySelected);
      }
    });
  }
})


